export const PrescribersProfileConstants = {
  DEFAULT_PRESCRIBER_LIST_SORTING : [
    { id: "prescriberName", desc: false, isDefault: true },
  ],
  DEFAULT_PRESCRIBER_LIST_FILTER: [],
  PRESCRIBER_STATES : [
    { key: "NO_CONTACT", value: "NO_CONTACT" },
    { key: "CONTACTED", value: "CONTACTED" },
    { key: "OPERATIONAL", value: "OPERATIONAL" },
    { key: "ESTABLISHED", value: "ESTABLISHED" },
    { key: "DO_NOT_CONTACT", value: "DO_NOT_CONTACT" },
  ],
  OPTED_OUT_FILTER : [
      { key: null, value: "All" },
    { key: true, value: "True" },
    { key: false, value: "False" },
  ]
}